import { supabase } from './supabase';

const confirmed = user => user && !user.is_anonymous && user.email_confirmed_at;

export async function confirmedGuestEmailSession() {
  const { data, error } = await supabase.auth.getSession();
  if (error) throw error;
  if (confirmed(data?.session?.user)) return data.session;
  if (!data?.session) throw Object.assign(new Error('Sign in again to finish your account.'), { code: 'session_not_found' });

  // Check the server before rotating a guest refresh token. Confirmation in
  // another browser can already have rotated that token.
  const checked = await supabase.auth.getUser();
  if (checked.error) throw checked.error;
  if (!confirmed(checked.data?.user)) return null;
  const refreshed = await supabase.auth.refreshSession();
  if (refreshed.error) throw refreshed.error;
  return confirmed(refreshed.data?.session?.user) ? refreshed.data.session : null;
}
